var map = {
	"./en": [
		774,
		445
	],
	"./en.js": [
		774,
		445
	],
	"./la": [
		775,
		417
	],
	"./la.js": [
		775,
		417
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 644;
module.exports = webpackAsyncContext;